// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"857acb36","869":"84f10ccf"}[chunkId] + ".chunk.js";
};